import { Component, inject } from '@angular/core';
import { NgStyle } from '@angular/common';
import { CorporateDesignService } from '../../../../services/corporate-design/corporate-design.service';
import { EEntityType, ERelationType } from '@web/dtos';
import { UserStore } from '../../../../services/api/user/user/user-store.service';
import { FilterTextsPipe } from '../../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../../pipes/language/language.pipe';
import { WebTextStore } from '../../../../services/api/text/web-text-store.service';
import { OnDemandTicketConfigurationSummaryComponent } from '../on-demand-ticket-configuration-summary/on-demand-ticket-configuration-summary.component';
import { OnDemandJourneyTimelineComponent } from '../on-demand-journey-timeline/on-demand-journey-timeline.component';
import { SalutationStore } from '../../../../services/api/salutation/salutation-store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OnDemandSelectionStateService } from '../../../../services/on-demand/on-demand-selection-state.service';
import { ERoute } from '../../../../constants/routes.enum';

@Component({
  selector: 'aw-on-demand-ticket-configuration-checkout',
  templateUrl: './on-demand-ticket-configuration-checkout.component.html',
  imports: [
    NgStyle,
    FilterTextsPipe,
    LanguagePipe,
    OnDemandTicketConfigurationSummaryComponent,
    OnDemandJourneyTimelineComponent,
  ],
})
export class OnDemandTicketConfigurationCheckoutComponent {
  protected readonly ERelationType = ERelationType;
  protected readonly EEntityType = EEntityType;

  protected readonly corporateDesign = inject(CorporateDesignService);
  protected readonly textStore = inject(WebTextStore);
  protected readonly userStore = inject(UserStore);
  protected readonly salutationStore = inject(SalutationStore);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly selectionState = inject(OnDemandSelectionStateService);

  constructor() {
    const pendingOrderId = this.selectionState.pendingOrderId();
    const isSuccessfulOnDemandRedirect =
      this.route.snapshot.queryParams['onDemandPayment'] === 'success';

    if (
      pendingOrderId &&
      isSuccessfulOnDemandRedirect &&
      this.selectionState.orderConfirmationPending()
    ) {
      void this.router.navigate(
        [`/${ERoute.onDemandTicketConfiguration}/${ERoute.payment}`],
        {
          queryParams: {
            onDemandPayment: 'success',
          },
          replaceUrl: true,
        }
      );
    }
  }
}
